import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight1 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: 0,
	y: 0,
	viewBox: "0 0 24 24",
	xmlSpace: "preserve",
	enableBackground: "new 0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.5 12c0 0.7 -0.3 1.3 -0.8 1.7L7.5 23.6c-0.8 0.7 -2 0.6 -2.6 -0.2 -0.6 -0.8 -0.6 -1.9 0.2 -2.6l9.8 -8.6c0.1 -0.1 0.1 -0.2 0 -0.4L5.1 3.2c-0.8 -0.7 -0.8 -1.9 -0.1 -2.6 0.7 -0.7 1.8 -0.8 2.6 -0.2l11.2 9.8c0.4 0.5 0.7 1.1 0.7 1.8z",
		fill: "currentColor",
		strokeWidth: 1
	})
});
export { SvgArrowRight1 as ReactComponent };
